import { Component, OnInit } from '@angular/core';
import { IntegrationService } from '../integration.service';
import { NotifierService } from "angular-notifier";

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  private readonly notifier: NotifierService;
  clicked = false;
  textAlerts = false;
  emailAlerts = false;
  areaCode = '1'
  userPhone = ''
  alertType = [];

  constructor(private _integrationService:IntegrationService,notifierService: NotifierService) {
    this.notifier = notifierService;
   }

  ngOnInit() {
  }

  updateAreaCode(value){
    console.log(value)
    this.areaCode = value;
  }

  updateUserPhone(value){
    console.log(value)
    this.userPhone = value;
  }

  getTextAlertClass(){
    if(this.textAlerts){
      return 'btn btn-primary subscrybeSelected'
    }
    return 'btn btn-outline-primary alertType'
  }

  getEmailAlertClass(){
    if(this.emailAlerts){
      return 'btn btn-primary subscrybeSelected'
    }
    return 'btn btn-outline-primary alertType'
  }

  setTextAlerts(){
    this.textAlerts = !this.textAlerts;
  }

  setEmailAlerts(){
    this.emailAlerts = !this.emailAlerts;
  }

  signUp(userName='',userEmail,userPassword){
    if(!userEmail || !userPassword){
      this.clicked = true;
      this.notifier.notify("error", "Looks like you forgot to add an email/password :(");
      this.clicked = false;
    } else if(!this.emailAlerts && !this.textAlerts){
      this.notifier.notify("error", "Please choose an alert type, so we can remind you when you're subscriptions are set to renew!");
    } else if(this.textAlerts && !this.userPhone){
      this.notifier.notify("error", "We need your phone number to send you text alerts!!");
    }else{
      //email,password, alerts, if text then phone
      this.clicked = true;
      let phoneWithArea = `+${this.areaCode}${this.userPhone}`
      if(this.emailAlerts){
        this.alertType.push('email')
      } if(this.textAlerts){
        this.alertType.push('text')
      }
      this._integrationService.registerUser(userName,userEmail,userPassword,phoneWithArea,this.alertType)
    }
  }
}
